const CONFIGURATION = {
	AWS_REGION: process.env.REACT_APP_AWS_REGION,
	AWS_COGNITO_IDENTITY_POOL_ID: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
	AWS_COGNITO_USER_POOL_ID: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
	AWS_COGNITO_CLIENT_ID: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
	AWS_API_SERVICE: process.env.REACT_APP_AWS_API_SERVICE ?? 'gateway',
	AWS_API_NAME: process.env.REACT_APP_AWS_API_NAME ?? 'nola-api',
	AWS_API_URL: ''.concat(process.env.REACT_APP_AWS_API_URL, '/api/v1'),
	ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT ?? 'dev',
	RESPONSUM_API_VERSION: process.env.REACT_APP_RESPONSUM_API_VERSION ?? 1,
	RESPONSUM_API_RESOURCE_TYPE: { SHARED: 's', PRIVATE: 'e' },
	RESPONSUM_API: process.env.REACT_APP_RESPONSUM_API ?? 'nola'
};
export default CONFIGURATION;
